import React, { memo } from 'react';

const ListIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M0 19.765h7.529v-7.529h-7.529v7.529zM0 29.176h7.529v-7.529h-7.529v7.529zM0 10.353h7.529v-7.529h-7.529v7.529zM9.412 19.765h22.588v-7.529h-22.588v7.529zM9.412 29.176h22.588v-7.529h-22.588v7.529zM9.412 2.824v7.529h22.588v-7.529h-22.588z"
        />
    </svg>
);

export default memo(ListIcon);
